<script setup lang="ts">
// Production-routable fixture for the anonymous route-guard e2e. Must not live under
// src/pages/test/** — Vite excludes that tree from production builds, which Playwright serves.
definePage({
  meta: {
    requiresAuth: false,
  },
})
</script>

<template>
  <RouterLink data-testid="route-guard-trigger" to="/user/settings/profile">
    Open profile
  </RouterLink>
</template>
